import { createRouter, createWebHashHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import HomePage from "../views/HomePage.vue";
import StrategyView from "@/views/StrategyView.vue";
import AllNewsView from "@/views/AllNewsView.vue"
import PricePredictionView from "@/views/PricePredictionView.vue";
import AboutUsView from "@/views/AboutUsView.vue";
import BlogList from '@/views/BlogList.vue'
import ReportsList from '@/views/ReportsList.vue'
import BlogDetail from '@/components/BlogDetail.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },  
  // {
  //   path: '/new',
  //   name: 'newHome',
  //   component: HomePage
  // },
  {
    path: '/strategy-detail',
    name: 'StrategyDetail',
    component: StrategyView
  },
  {
    path: '/all-news',
    name: 'AllNews',
    component: AllNewsView
  },
  {
    path: '/price-prediction',
    name: 'PricePredictionView',
    component: PricePredictionView
  },
  {
    path: '/about-us',
    name: 'AboutUsView',
    component: AboutUsView
  },
  {
    path: '/vaults',
    name: 'StrategyVaults',
    component: () => import('@/views/StrategyVaults.vue')
  },

  { path: '/blogs', name: 'BlogList', component: BlogList },
  { path: '/reports', name: 'ReportsList', component: ReportsList },
  { path: '/blogs/:id', name: 'BlogDetail', component: BlogDetail },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to, from, next) => {
  document.title = "ZKware.AI 全天候加密智库"
  next()
})

export default router
